﻿import { createElement, onEvent } from "./_dom";
import { computePosition, autoUpdate } from '@floating-ui/dom';

let tooltip, popperCleanup;

function copyText(context, selector, options = undefined) {
	options = {
		value: "innerText", // innerText to copy text
		message: "Text is copied to clipboard",
		tooltipClass: "v3-tooltip",
		// appendTo: document.body,
		...options
	};
	if (typeof options.value === "string") {
		options.value = (s => el => el[s])(options.value);
	} 
	onEvent(context, selector, "click", (e, el) => {
		if (e.button === 0 && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
			e.preventDefault();
			var textToCopy = options.value(el);
			navigator.clipboard.writeText(textToCopy).then(() => {
				if (!tooltip) {
					tooltip = createElement("div", { "class": options.tooltipClass }, options.message);
					(options.appendTo || document.body).appendChild(tooltip);
				}
				popperCleanup?.();
				popperCleanup = autoUpdate(el, tooltip, () => computePosition(el, tooltip).then(({ x, y }) => { tooltip.style.left = `${x}px`; tooltip.style.top = `${y}px`; }));
				setTimeout(function () {
					popperCleanup?.();
					popperCleanup = null;
					tooltip?.remove();
					tooltip = null;
				}, 1000);
			}, err =>  {
				alert(err);
			});
		}
	});
}

function init(context) {
	copyText(context, "a.js-copyhref", { value: "href", message: "Link is copied to clipboard" });
	copyText(context, "input.js-copy-input,textarea.js-copy-input", { value: input => input.value });
	copyText(context, "button.js-copy-input", { value: button => button.previousElementSibling.value });
}

export { init };